/**
 * Reorder the visible product grid when Filter & Sort is "Most reviewed".
 * Shopify has no native collection sort for review count, so we sort the
 * current page of cards by data-review-count after each render.
 */
(function () {
  if (window.__croMostReviewedSort) return;
  window.__croMostReviewedSort = true;

  function isMostReviewed() {
    try {
      return new URL(window.location.href).searchParams.get('sort_by') === 'most-reviewed';
    } catch (e) {
      return false;
    }
  }

  function apply() {
    if (!isMostReviewed()) {
      document.querySelectorAll('.product-grid[data-cro-sorted]').forEach((grid) => {
        delete grid.dataset.croSorted;
      });
      return;
    }

    document.querySelectorAll('.product-grid').forEach((grid) => {
      const items = [...grid.children].filter((el) => el.classList && el.classList.contains('product-grid__item'));
      if (items.length < 2) return;
      if (grid.dataset.croSorted === 'most-reviewed' && Number(grid.dataset.croSortedCount) === items.length) return;
      items.sort((a, b) => (Number(b.dataset.reviewCount) || 0) - (Number(a.dataset.reviewCount) || 0));
      items.forEach((el) => grid.appendChild(el));
      grid.dataset.croSorted = 'most-reviewed';
      grid.dataset.croSortedCount = String(items.length);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('collection:update', () => {
    requestAnimationFrame(apply);
  });

  const observer = new MutationObserver(() => apply());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
